import { MenuItem, Select } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import OptionAddon from "./optionAddon";

const typeList = [
  {
    name: "text",
  },
  {
    name: "number",
  },
  {
    name: "password",
  },
  {
    name: "email",
  },
  {
    name: "date",
  },
  {
    name: "time",
  },
  {
    name: "file",
  },
  {
    name: "radio",
  },
  {
    name: "checkbox",
  },
  {
    name: "date-time-local",
  },
  {
    name: "select",
  },
  // {
  //   name: "multiselect",
  // },
];

const optionObj = {
  title: "",
  value: "",
};
const DependAddons = ({
  data,
  handleChange,
  activeTab,
  setPersonalInfo,
  handleSaveField,
}) => {
  const [state, setState] = useState({
    addons: data,
  });
  const [isChange, setIsChange] = useState(false);
  const [saveChange, setSaveChange] = useState(false);
  const [addState, setAddState] = useState({
    name: "",
    age: "",
    relationship: "",
  });

  useEffect(() => {
    setState({ addons: data });
  }, [data]);

  useEffect(() => {
    if (activeTab === "personalInfo") {
      handleChange(state.addons, "personal_information");
    } else if (activeTab === "empInfo") {
      handleChange(state.addons, "employment_information");
    } else if (activeTab === "otherFinancialInfo") {
      handleChange(state.addons, "other_financial_information");
    } else if (activeTab === "personalAssets") {
      handleChange(state.addons, "personal_assets");
    } else if (activeTab === "realPropertyOwned") {
      handleChange(state.addons, "real_property_owned");
    } else if (activeTab === "vehicles") {
      handleChange(state.addons, "vehicles");
    } else if (activeTab === "assets") {
      handleChange(state.addons, "assets");
    } else if (activeTab === "incomeExpenseStatement") {
      handleChange(state.addons, "income");
    } else if (activeTab === "legal") {
      handleChange(state.addons, "legal");
    } else if (activeTab === "bankruptcy") {
      handleChange(state.addons, "bankruptcy");
    }
  }, [isChange]);

  const addRow = (e) => {
    e.preventDefault();
    if (state.addons.length > 0) {
      setState((pre) => ({
        ...pre,
        addons: [...pre.addons, addState],
      }));
    } else {
      setState((pre) => ({
        ...pre,
        addons: [addState],
      }));
    }
  };

  const deleteRow = (e, index) => {
    e.preventDefault();
    const addons = state.addons.filter((e, i) => i !== index);
    setState({
      addons: [...addons],
    });
    setIsChange(!isChange);
    setSaveChange(!saveChange);
    // if (state.addons.length === 1) {
    //   handleSaveField();
    // }
  };

  // useEffect(() => {
  //   if (state.addons.length > 0) {
  //     handleSaveField();
  //   }
  // }, [JSON.stringify(state.addons)]);

  const addOptionRow = (e, i) => {
    e.preventDefault();
    setState((pre) => ({
      ...pre,
      addons: [
        ...pre.addons.slice(0, i),
        {
          ...pre.addons[i],
          option: [...pre.addons[i].option, optionObj],
        },

        ...pre.addons.slice(i + 1),
      ],
    }));
  };

  const deleteOptionRow = (e, i, optionIndx) => {
    e.preventDefault();
    setState((pre) => ({
      ...pre,
      addons: [
        ...pre.addons.slice(0, i),
        {
          ...pre.addons[i],
          option: pre.addons[i].option.filter((_, indx) => indx !== optionIndx),
        },

        ...pre.addons.slice(i + 1),
      ],
    }));
  };

  const changeRowvalue = (e, i, optionIndx) => {
    const { name, value } = e.target;

    if (optionIndx >= 0) {
      setState((pre) => ({
        ...pre,
        addons: [
          ...pre.addons.slice(0, i),
          {
            ...pre.addons[i],
            option: [
              ...pre.addons[i].option.slice(0, optionIndx),
              {
                ...pre.addons[i].option[optionIndx],
                [name]: value,
              },
              ...pre.addons[i].option.slice(optionIndx + 1),
            ],
          },

          ...pre.addons.slice(i + 1),
        ],
      }));
    } else {
      setState((pre) => ({
        ...pre,
        addons: [
          ...pre.addons.slice(0, i),
          {
            ...pre.addons[i],
            [name]: value,
          },

          ...pre.addons.slice(i + 1),
        ],
      }));
    }
    setIsChange(!isChange);
  };

  return (
    <>
      {state.addons &&
        state.addons.map((s, i) => {
          return (
            <div className="my-2">
              <Row className="align-items-center columns-fields">
                <Col md={3} className="range-inner">
                  <label htmlFor="title">Name</label>
                  <input
                    type="text"
                    name="name"
                    value={s.name}
                    onChange={(e) => changeRowvalue(e, i)}
                    placeholder=""
                    className="form-control"
                  />
                </Col>
                <Col
                  md={3}
                  className="range-inner doc-select field-type-select"
                >
                  <label htmlFor="title">Age</label>
                  <input
                    type="number"
                    name="age"
                    value={s.age}
                    onChange={(e) => changeRowvalue(e, i)}
                    placeholder=""
                    className="form-control"
                  />
                </Col>
                <Col md={3} className="range-inner">
                  <label htmlFor="title">Relationship</label>
                  <input
                    type="text"
                    name="relationship"
                    value={s.relationship}
                    onChange={(e) => changeRowvalue(e, i)}
                    placeholder=""
                    className="form-control"
                  />
                </Col>
                <Col md={3}>
                  <div className=" text-end pt-4">
                    <button
                      className="remove-btn address-btn-remove address-remove position-relative"
                      onClick={(e) => deleteRow(e, i, "addons")}
                    >
                      Remove Field
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          );
        })}
      {/* {state.addons?.length > 0 && ( */}
      <div className="text-end pt-3">
        <Button className="" onClick={() => handleSaveField(state.addons)}>
          Save Fields
        </Button>
      </div>
      {/* )} */}
      <div className="expension-btn text-left">
        <button
          type="button"
          className="expension-button text-center"
          data-toggle="modal"
          data-target="#exampleModalScrollable1"
          onClick={(e) => addRow(e, "addons")}
        >
          Add More
        </button>
      </div>
    </>
  );
};

export default React.memo(DependAddons);
